module.exports = __webpack_public_path__ + "img/details_5.2803df44.jpg";